"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFilterExists = exports.getProperties = exports.getShadow = exports.getFilter = void 0;
const svgFiltersTemplates_1 = require("./svgFiltersTemplates");
const svgPresets_1 = require("./svgPresets");
function getFilter(id, name, overrides, attrs) {
    const filter = svgPresets_1.filterPresets[name] || [];
    return (0, svgFiltersTemplates_1.interpolate)(id, filter, overrides || {}, attrs);
}
exports.getFilter = getFilter;
function getShadow(id, shadow) {
    return (0, svgFiltersTemplates_1.interpolate)(id, [{ key: 'shadow', value: shadow }], {});
}
exports.getShadow = getShadow;
function getProperties(name, overrides) {
    const filter = svgPresets_1.filterPresets[name] || [];
    return (0, svgFiltersTemplates_1.getProperties)(filter, overrides || {});
}
exports.getProperties = getProperties;
function isFilterExists(effectName) {
    return effectName in svgPresets_1.filterPresets;
}
exports.isFilterExists = isFilterExists;
//# sourceMappingURL=svgFilters.js.map